import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
export default function ArtsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-testid": "icon-arts",
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 10,
    rx: 1.934,
    transform: "matrix(-1 0 0 1 52 40)",
    fill: "#9DC3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 10,
    rx: 1.934,
    transform: "matrix(-1 0 0 1 51 19)",
    fill: "#70A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 20.934A1.934 1.934 0 0049.066 19H27a1 1 0 100 2h24v-.066z",
    fill: "#468CFB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 11,
    rx: 1.934,
    transform: "matrix(-1 0 0 1 57 29)",
    fill: "#AB52DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 31H34.45c-.8 0-1.45.65-1.45 1.45v4.1c0 .8.65 1.45 1.45 1.45H57v-7zM26 21H2v6h24c-.326-2.343-.336-3.657 0-6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 41.934A1.934 1.934 0 0050.066 40H4.934A1.934 1.934 0 003 41.934V42h49v-.066z",
    fill: "#70A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00307A",
    strokeWidth: 1.934,
    strokeLinecap: "round",
    d: "M8.967 39.033H31.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.467 30.825s.494 1.922.502 3.197c.008 1.326-.502 3.33-.502 3.33",
    stroke: "#0247B8",
    strokeWidth: 1.934,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 9,
    rx: 1.934,
    transform: "matrix(-1 0 0 1 51 10)",
    fill: "#DEAAFB"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9846C3",
    strokeWidth: 1.934,
    strokeLinecap: "round",
    d: "M19.782 13.782h20.153"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#70A7FF",
    strokeWidth: 1.934,
    strokeLinecap: "round",
    d: "M24.468 24.232H2.966"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9C5FC",
    strokeWidth: 2.417,
    strokeLinecap: "round",
    d: "M15.209 33.791h12.582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 34H37",
    stroke: "#70A7FF",
    strokeWidth: 1.934,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.086 20.998s-.537 1.525-.545 2.538c-.009 1.052.545 2.643.545 2.643",
    stroke: "#0247B8",
    strokeWidth: 1.934,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0452D0",
    d: "M30 19h2v9h-2zM47 19h2v10h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0452D0",
    strokeWidth: 3.868,
    strokeLinecap: "round",
    d: "M36.934 23.066h5.949"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0452D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M9.5 45.5h24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 33h9v10.818a1 1 0 01-1.653.757L43.36 42l-2.683 2.462c-.641.588-1.676.134-1.676-.737V33z",
    fill: "#0247B8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB52DA",
    d: "M12 10h2v9h-2zM44 10h2v9h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00307A",
    strokeWidth: 1.934,
    strokeLinecap: "round",
    d: "M9.967 18.033h40.066M28.196 28.064h22.842"
  }));
}